"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Dialog = ({
  children,
  container,
  header,
  id,
  onClose,
  open,
  zIndex
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    drawer: true,
    "data-testid": getTestId(_constants.PRODUCT_INFO_DIALOG_DIALOG),
    container: container,
    header: header ?? null,
    id: id,
    open: open ?? false,
    size: "small",
    zIndex: zIndex,
    onClose: onClose,
    children: children
  });
};
exports.Dialog = Dialog;